import React, { memo } from 'react';
import classnames from 'classnames';
import { useClasses } from '../../../../utils/overrides';
import { createUseStyles } from '../../../../utils/styles';
import { POSITION } from '../constants';
import Toast from '../Toast';

import styles from './styles';

const useStyles = createUseStyles(styles, 'ToastGroup');

const ToastGroup = memo(
    ({
        position,
        toasts,
        removeToast,
        clearDeletedToast,
        preComponent,
        postComponent,
        override,
    }) => {
        const classes = useClasses(useStyles);
        const rootClassName = classnames(classes.root, {
            [classes.topLeft]: POSITION[position] === 'top-left',
            [classes.topCenter]: POSITION[position] === 'top-center',
            [classes.topRight]: POSITION[position] === 'top-right',
            [classes.bottomLeft]: POSITION[position] === 'bottom-left',
            [classes.bottomCenter]: POSITION[position] === 'bottom-center',
            [classes.bottomRight]: POSITION[position] === 'bottom-right',
        });

        if (!toasts?.length && !preComponent && !postComponent) return null;

        return (
            <div className={rootClassName} {...override?.ToastGroup}>
                {preComponent && preComponent}
                {toasts.map((t) => (
                    <Toast
                        key={t.id}
                        id={t.id}
                        type={t.type}
                        position={position}
                        title={t.title || ''}
                        text={t.text || ''}
                        content={t.content || null}
                        icon={t.icon || null}
                        isActive={t.isActive}
                        onClose={() => {
                            t.onClose?.();
                            removeToast(t.id);
                        }}
                        onClick={t.onClick}
                        closeButton={t.closeButton}
                        useDefaultCloseButton={t.useDefaultCloseButton}
                        closeOnClick={t.closeOnClick}
                        onClickLink={t.onClickLink}
                        linkText={t.linkText}
                        clearDeletedToast={clearDeletedToast}
                        override={override?.Toast}
                    />
                ))}
                {postComponent && postComponent}
            </div>
        );
    },
);

export default ToastGroup;
